import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { ExamService } from '../_services/exam.service';
import { AlertifyService } from '../_services/alertify.service';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ReadingModel } from '../_models/ReadingModel';

@Injectable()
export class ReadingDetailResolver implements Resolve<ReadingModel> {
    constructor(private examService: ExamService, private router: Router, private alertify: AlertifyService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<ReadingModel> {
        return this.examService.getReading(route.params['id']).pipe(
            catchError(error => {
                this.alertify.error('problem retriving your data');
                this.router.navigate(['/readings']);
                return of(null);
            })
        );
    }
}